import OutlinedInput from "@material-ui/core/OutlinedInput";
export default OutlinedInput;

export let styles = theme => ({
  root: {
    padding: "9px 8px 8px",
    "&.MuiAutocomplete-inputRoot": {
      padding: "9px 32px 8px 8px",
      "&:hover, &.Mui-focused": {
        paddingRight: "60px"
      }
    },
    "label + &": {
      marginTop: "18px"
    },
    "&:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderStyle: "dotted"
    }
  },
  input: {
    "&, .MuiAutocomplete-inputRoot &.MuiAutocomplete-input, .MuiAutocomplete-inputRoot &.MuiAutocomplete-input:first-child": {
      padding: "unset"
    }
  },
  multiline: {
    // hack to nicely display the scroll bar,
    // and still prevent text from hitting the border
    padding: "7px 2px 6px 8px"
  }
});
